module.exports = __webpack_public_path__ + "static/media/sound-on.2f8adb35.svg";